import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import CardActionArea from '@material-ui/core/CardActionArea';

import ExposureOutlinedIcon from '@material-ui/icons/Exposure';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(theme => ({
    actionArea: {
        display: 'block',
        height: '100%',
        borderRadius: 16,
        transition: 'all 0.15s ease',
        '&:hover': {
            boxShadow: '0 4px 12px rgba(63, 81, 181, 0.12)',
            transform: 'translateY(-2px)'
        }
    },
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 16,
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)'
    },
    content: {
        flex: 1,
        padding: theme.spacing(3)
    },
    headerRow: {
        marginBottom: theme.spacing(2)
    },
    title: {
        fontWeight: 700,
        fontSize: '1.05rem',
        color: '#111827'
    },
    number: {
        fontWeight: 700,
        color: '#111827',
        marginTop: theme.spacing(0.5)
    },
    icon: {
        width: 44,
        height: 44,
        minWidth: 44,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(63, 81, 181, 0.1)',
        color: '#3f51b5'
    },
    footer: {
        padding: theme.spacing(1.5, 3),
        borderTop: '1px solid #EEF0F4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    footerLabel: {
        fontWeight: 600,
        color: '#3f51b5',
        fontSize: '0.9rem'
    },
    chevron: {
        color: '#3f51b5'
    }
}));

const AttendancePoint = props => {
    const { className, data, ...rest } = props;

    const classes = useStyles();

    return (
        <CardActionArea
            component={RouterLink}
            to={'/settings/attendance-point'}
            className={classes.actionArea}>
            <Card {...rest} className={clsx(classes.root, className)}>
                <CardContent className={classes.content}>
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        justify="space-between"
                        alignItems="flex-start"
                        className={classes.headerRow}>
                        <Grid item xs zeroMinWidth>
                            <Typography className={classes.title}>
                                Gestion des points d'assiduité
                            </Typography>
                            <Typography variant="h3" className={classes.number}>
                                {data.records}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <div className={classes.icon}>
                                <ExposureOutlinedIcon fontSize="small" />
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>

                <div className={classes.footer}>
                    <Typography className={classes.footerLabel}>
                        Gérer les points d'assiduité
                    </Typography>
                    <ChevronRightIcon fontSize="small" className={classes.chevron} />
                </div>
            </Card>
        </CardActionArea>
    );
};

export default AttendancePoint;
